import moment from 'moment';

import { MIDNIGHT } from 'pages/utils/time';
import { START_TIME, END_TIME } from './index';

export const validateTime = ({ name, value, oppositeValue, format }) => {
  const type = {
    [START_TIME]: 'start time',
    [END_TIME]: 'end time',
  };
  const validatedTime = moment(value, format);
  const oppositeTime = moment(oppositeValue, format);

  if (value === '') {
    return `Select or enter ${type[name]}.`;
  }

  if (!validatedTime.isValid()) {
    return `Enter valid ${type[name]} format (${format}).`;
  }

  if (
    validatedTime.format(format) === oppositeTime.format(format) &&
    validatedTime.format(format) !== MIDNIGHT.format(format)
  ) {
    return `Enter different ${type[START_TIME]} and ${type[END_TIME]}.`;
  }

  if (name === START_TIME) {
    if (validatedTime.isAfter(oppositeTime)) {
      return `Enter ${type[START_TIME]} before ${type[END_TIME]}.`;
    }
  } else if (validatedTime.isBefore(oppositeTime)) {
    return `Enter ${type[END_TIME]} after ${type[START_TIME]}.`;
  }

  return '';
};

export const validate = timeFormat => values => {
  const errors = {};
  const startTimeValidation = validateTime({
    name: START_TIME,
    value: values[START_TIME],
    oppositeValue: values[END_TIME],
    format: timeFormat,
  });

  const endTimeValidation = validateTime({
    name: END_TIME,
    value: values[END_TIME],
    oppositeValue: values[START_TIME],
    format: timeFormat,
  });

  if (startTimeValidation) {
    errors[START_TIME] = startTimeValidation;
  }

  if (endTimeValidation) {
    errors[END_TIME] = endTimeValidation;
  }

  return errors;
};
